module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/website-white-c022f3813d46d5a33e07475b25ef36cb.svg";